import { createAsyncThunk } from "@reduxjs/toolkit";

import { submitRegisteredEmail, submitResetPassword } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const submitEmail = createAsyncThunk(
  "users/submitEmail",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { adapter, users } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { registeredEmail } = users;

      const response = await submitRegisteredEmail(token, baseUrl, {
        email: registeredEmail
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const submitPassword = createAsyncThunk(
  "users/submitPassword",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { adapter, users, questions } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { resetPasswordToken } = users;
      const { answers } = questions;

      const response = await submitResetPassword(token, baseUrl, {
        reset_password_token: resetPasswordToken,
        password: answers.forgotPassword,
        password_confirmation: answers.forgotPassword
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
